<template>
  <div
    id="actionplan"
    class="action-plan"
    v-if="
      satContent &&
        satContent.Tools &&
        currentAssessment &&
        currentAssessment.Id
    "
  >
    <div class="form-row cta-group">
      <a role="navigation" href="#" @click="routeToSummary()" @keydown.enter="routeToSummary()" class="back-assessment-link"
        ><span class="angle-circle-left-green"></span><div>Back to
        <strong>Overview</strong></div></a
      >
    </div>

    <h1 class="page-title">{{ currentAssessment.Name }}</h1>
    <h4 class="title">Detailed summary</h4>
    <div class="row">
      <div class="col-lg-8">
        <div
          class="html-content"
          v-html="currentAssessment.ActionPlanIntroduction"
        ></div>
      </div>
    </div>
    <div class="form-row">
      <div class="col-12 d-flex flex-column flex-md-row">
        <!-- TODO: save and print functionality -->
        <div class="download dropdown show">
          <a role="button"
            name="actionplan-download"
            id="actionplan-actionplan"
            class="dropdown-toggle"
            href="#"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Download this summary
          </a>

          <div class="dropdown-menu" aria-labelledby="actionplan-actionplan">
            <div @click="saveAsPDF()" class="dropdown-item">Save as PDF</div>
            <div @click="printPDF()" class="dropdown-item">Print</div>
          </div>
        </div>
        <a role="navigation"
          class="feedback-link"
          :href="currentAssessment.FeedbackLinkUrl"
          :target="currentAssessment.FeedbackLinkTarget"
          >{{ currentAssessment.FeedbackLinkText }}</a
        >
      </div>
    </div>

    <div class="my-5">
      <!-- <h4 class="title">Action plan info</h4> -->
      <hr class="solid" />
      <div class="form-row">
        <div class="col-12 col-md-6 col-lg-4">
          <div class="name">Contact name</div>
          <div class="body">
            {{
              (this.user.FirstName ? this.user.FirstName : "")
            }}
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <div class="name">Created on</div>
          <div class="body">{{ this.savedAssessmentDateCreated }}</div>
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <div class="name">Last updated</div>
          <div class="body">{{ this.dateUpdated }}</div>
        </div>
      </div>
    </div>    

    <div>
      <div
        class="list-group mb-5"
        v-for="(standard, i) in currentAssessment.Standards"
        :key="standard.Id"
      >
        <ActionPlanStandard :standard="standard" :standardNumber="i + 1" />
      </div>
    </div>

    <a class="link-active float-right" @click="backToTop()"  @keydown.enter="backToTop()" tabindex="0">
      <span class="angle-square-up-green"></span>Back to top
    </a>
    <div class="space"></div>

    <ActionPlanPDFSave id="actionPlanPDFSave" ref="actionPlanPDFSave" :satId="satId" />    
    <ActionPlanPDFPrint id="actionPlanPDFPrint" ref="actionPlanPDFPrint" :satId="satId" />    
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { GET_SATCONTENTACTION } from "../store/mutation-types";
import { privateRouter } from "../router";
import moment from "moment";
import ActionPlanStandard from "@/components/actionplan-standard";
import ActionPlanPDFSave from "@/components/actionplan-pdf-save";
import ActionPlanPDFPrint from "@/components/actionplan-pdf-print";

export default {
  name: "ActionPlan",
  components: {
    ActionPlanStandard,
    ActionPlanPDFSave,
    ActionPlanPDFPrint
  },
  data() {
    return {};
  },
  props: {
    satId: {
      type: Number,
      default: () => 0
    }
  },
  async created() {
    await this.loadSatContent();
  },
  methods: {
    ...mapActions([GET_SATCONTENTACTION]),
    async loadSatContent() {
      /* if(!this.satContent || !this.satContent.Tools){ // get satContent from API if not in the store (e.g. hitting this route before overview page)
                    await this.getSatContentAction();
                }  */

      // always get satContent from DB for action plan
      await this.getSatContentAction();
    },
    routeToOverview() {
      privateRouter.push({
        name: "SATs",
        query: {
          activeTab: 1
        }
      });
    },
    routeToSummary() {      
      privateRouter.push({
        name: "AssessmentStart",
        query: {
          satId: this.satId
        }
      });      
    },
    backToTop() {
      window.scrollTo(0, 0);
    },
    saveAsPDF() {
      this.$refs.actionPlanPDFSave.generateReport();
    },
    printPDF() {
      this.$refs.actionPlanPDFPrint.generateReport();
    }
  },
  computed: {
    ...mapState({
      satContent: state => state.satContent,
      user: state => state.users.user
    }),
    currentAssessment: {
      get() {
        return this.satContent && this.satContent.Tools && this.satId
          ? this.satContent.Tools.filter(tool => {
              return tool.Id === this.satId;
            })[0]
          : {};
      },
      set() {}
    },
    dateUpdated() {
      let savedResponses = [];

      // get saved responses for this assessment
      this.currentAssessment.Standards.forEach(standard => {
        standard.Sections.forEach(section => {
          section.Questions.forEach(question => {
            if(question.SAT_SavedResponses.Id) { // responses sometimes hang around as empty objects after being deleted
              savedResponses.push(question.SAT_SavedResponses); 
            }
          })
        })
      })

      if(savedResponses) {
        savedResponses.sort(function(savedResponses,b){ // sort responses by DateUpdated descending
          return new Date(b.DateUpdated) - new Date(savedResponses.DateUpdated)
        })
        return moment(savedResponses[0].DateUpdated).format("LL") // get last saved response
      } else {
        return "Assessment not saved";
      }
    },
    savedAssessmentDateCreated() {
      return this.currentAssessment.SavedAssessmentDateCreated
        ? moment(this.currentAssessment.SavedAssessmentDateCreated).format("LL")
        : "Assessment not saved";
    }
  }
};
</script>

<style lang="sass" scoped></style>
